import { BaseService, RequestType } from "@intech/react-service";
import { CalendarioPagamentoEntidade } from "../entidades";

class Calendario extends BaseService {

  constructor() {
    super("calendarioPagamento");
  }

  Buscar = () =>
    this.CreateRequest<Array<CalendarioPagamentoEntidade>>(RequestType.GET);

  BuscarPorPlano = (cdPlano: string) =>
    this.CreateRequest<Array<CalendarioPagamentoEntidade>>(RequestType.GET, `porPlano/${cdPlano}`);

}

export const CalendarioPagamentoService = new Calendario();